module.exports = __webpack_public_path__ + "img/xiao2.b10ec11d.png";